import EventCategoryRequirementBadge from "./EventCategoryRequirementBadge";

export default EventCategoryRequirementBadge;
